<template>
  <div
    class="count-down"
    v-if="totalTimeM"
    :style="{
      height: pxOrVw(extraItem.extras('nav.model')),
      display: extraItem.extras('nav.display') == 1 ? 'flex' : 'none',
      fontSize: pxOrVw(extraItem.extras('nav.model') / 4),
    }"
  >
    <div v-if="platform === 'pc'">
      <span>答题超过{{ totalTimeM }}分钟后，自动提交，剩余答题时长</span>
      <span class="count-down-time">&nbsp;{{ timeRemaining }}</span>
    </div>
    <div v-if="platform === 'wap'">
      <span>剩余答题时长</span>
      <span class="count-down-time">&nbsp;{{ timeRemaining }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountDown",
  props: {
    extras: Object,
    platform: {
      type: String,
      default: "pc",
    },
    totalTimeM: {
      //总时长，分钟数/为0表示不限时长
      type: Number,
      default: 0,
    },
    costTime: {
      //时间偏移量
      type: Number,
      default: 0,
    },
  },
  computed: {
    totalTime() {
      return Math.floor(this.totalTimeM * 60);
    },
    timeRemaining() {
      let _minute = Math.floor(this.passTime / 60);
      let _seconds = this.passTime % 60;
      let minutes = _minute < 0 ? "00" : _minute < 10 ? "0" + _minute : _minute;
      let seconds =
        _seconds < 0 ? "00" : _seconds < 10 ? "0" + _seconds : _seconds;
      return `${minutes}分${seconds}秒`;
    },
    timeOut() {
      //超时状态
      return this.passTime <= 0 ? true : false;
    },
    costTimeFront() {
      if (this.totalTimeM) {
        return this.costTime > this.totalTime
          ? this.totalTime
          : this.totalTime - this.passTime;
      }
      return this.passTime;
    },
  },
  data() {
    return {
      times: null, //计时器
      progress: 0, //进度
      passTime: 0, //已走时长||剩余时长
    };
  },
  methods: {
    //开始计时
    init() {
      let _this = this;
      if (_this.times) {
        clearInterval(_this.times);
        _this.passTime = 0;
      }
      if (!_this.totalTime) {
        //不设时长
        _this.passTime = _this.costTime; //已走时长
        _this.times = setInterval(() => {
          _this.passTime = _this.passTime + 1;
        }, 1000);
      } else {
        //倒计时
        _this.passTime = _this.totalTime - _this.costTime;
        _this.times = setInterval(() => {
          if (_this.passTime <= 0) {
            clearInterval(_this.times);
            _this.autoAction();
            return;
          }
          _this.passTime = _this.passTime - 1;
        }, 1000); //一秒一帧
      }
    },
    //自动提交
    autoAction() {
      let timeNow = 3;
      let timer = setInterval(() => {
        timeNow = timeNow - 1;
        document.getElementById("time-now").innerHTML = timeNow;
        if (timeNow <= 0) {
          clearInterval(timer);
          this.$emit("autoSubmit", 1);
          document.getElementsByClassName("sk-alert-ok")[0].click(); //关闭弹窗
        }
      }, 1000);
      window.$sk.alert(
        "<div id='my-alert' style='font-weight: bold;margin-bottom: 10px'>答题时间已到</div><div>答题时间已超过" +
          this.totalTimeM +
          "分钟，<span id='time-now'>3</span>s后自动提交!</div>",
        {
          okValue: "知道了",
          ok: () => {
            clearInterval(timer);
            this.$emit("autoSubmit", 1);
          },
        }
      );
    },
    onbeforeunloader(type = 0) {
      if (type) return (window.onbeforeunload = null);
      //页面刷新、关闭、后退时触发
      window.onbeforeunload = function (e) {
        e = e || window.event;
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = "关闭提示";
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "答题时间和已答项会重置，请谨慎操作";
      };
    },
    blurOrfocus() {
      let _this = this;
      window.onfocus = function () {
        if (!_this.timeOut) {
          //未超时，需要校准时间
          _this.$emit("calibration");
        }
      };
      window.onblur = function () {};
      // for IE
      document.onfocusin = function () {
        if (!_this.timeOut) {
          //未超时，需要校准时间
          _this.$emit("calibration");
        }
      };
      document.onfocusout = function () {};
    },
    clearMyInterval() {
      //清除定时器
      clearInterval(this.times);
    },
  },
};
</script>

<style lang="scss" scoped>
.count-down {
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  right: 30px;
  color: #555555;
}

.count-down-time {
  color: #1665d8;
}
</style>
